@if (action(); as actionKind) {
  <button
    type="button"
    class="create-event-fab"
    appFocusTarget="create-event"
    [attr.aria-label]="labelKey() | translate"
    [attr.title]="labelKey() | translate"
    (click)="open($event)">
    @switch (actionKind) {
      @case ('sb') {
        <svg
          aria-hidden="true"
          lucideShieldAlert
          [size]="26"></svg>
      }
      @case ('nnr') {
        <svg
          aria-hidden="true"
          lucideTriangleAlert
          [size]="26"></svg>
      }
      @default {
        <svg
          aria-hidden="true"
          lucideListPlus
          [size]="26"></svg>
      }
    }
  </button>
}
